import { isForeignerByUinfin } from "@wog/mol-lib-api-contract/utils/data/sg-uinfin";
import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface } from "class-validator";
import { PersonalDetailsDtoV2 } from "common/api/acp/domainObjects/acpDraft";

@ValidatorConstraint({ name: "IsValidResidentialAndPassType", async: false })
export class ValidResidentialAndPassType implements ValidatorConstraintInterface {
	validate(_content: string, args: ValidationArguments): boolean {
		return validateResidentialStatusAndPassType(args.object as PersonalDetailsDtoV2);
	}

	defaultMessage(args: ValidationArguments): string {
		const personalDetails = args.object as PersonalDetailsDtoV2;
		const isForeigner = isForeignerByUinfin(personalDetails.uinfin);

		if (isForeigner) {
			return 'For foreigners, "passtype" must be defined and "residentialStatus" must be empty.';
		}

		// Citizen/PR uinfin
		return 'For Citizens/PRs, "residentialStatus" must be defined and "passtype" must be empty.';
	}
}

export const validateResidentialStatusAndPassType = (value?: PersonalDetailsDtoV2): boolean => {
	if (!value) {
		return false;
	}

	const isForeigner = isForeignerByUinfin(value.uinfin);
	const { passtype, residentialStatus } = value;

	if (isForeigner) {
		return typeof passtype === "string" && passtype.trim() !== "" && residentialStatus === "";
	}

	// Citizen/PR uinfin
	return typeof residentialStatus === "string" && residentialStatus.trim() !== "" && passtype === "";
};
